import axios from "axios";

export const serverInstance = axios.create({
  baseURL: "https://7oqg4fwsk1.execute-api.ap-northeast-2.amazonaws.com/Prod/",
  headers: {
    'Accept': 'application/json',
    "Content-type": "application/json; charset=UTF-8",
  },
});
